import { combineReducers } from "@reduxjs/toolkit";
import { api } from "_shared/_stores/api";
import connectionHealthReducer from "_shared/_stores/realtime/connection-health-redux-slice";
import { documentsSlice } from "documents/_stores/documents-redux-slice";
import { entityMembersSlice } from "_shared/entity-members/_stores/entity-members-redux-slice";
import proposalsSlice from "work/proposals/_store/proposals-redux-slice";
import { entityAgreementsSlice } from "legal-entities/agreements/_stores/entity-agreements-redux-slice";
import userEntityMemberInvitationsSlice from "legal-entities/invitations/member-invitations/email-based/_stores/user-entity-member-invitation-redux-store";
import openEntityMemberInvitationsSlice from "legal-entities/invitations/member-invitations/open/_stores/open-entity-member-invitations-redux-slice";
import officerInvitationsSlice from "legal-entities/invitations/officer-invitations/_stores/entity-officer-invitations-redux-slice";
import { bookmarksSlice } from "marketplace/bookmarks/_store/bookmarks-redux-slice";
import { companiesSlice } from "marketplace/companies/_store/companies-redux-slice";
import { individualsSlice } from "marketplace/individuals/_stores/individuals-redux-slice";
import { marketplaceTeamsSlice } from "marketplace/teams/_store/marketplace-teams-redux-slice";
import { feeSchedulesSlice } from "marketplace/teams/fee-schedules/_stores/fee-schedule-redux-slice";
import messagesSlice from "messaging/_stores/messages-redux-slice";
import attachmentsSlice from "messaging/attachments/_stores/message-attachments-redux-slice";
import forumsSlice from "messaging/forums/_stores/forums-redux-slice";
import notificationsSlice from "notifications/entities/notification/store/notifications-redux-slice";
import permissionTemplatesSlice from "permissions/_stores/permission-templates-redux-slice";
import permissionsSlice from "permissions/_stores/permissions-redux-slice";
import feeScheduleTemplatesSlice from "work/fee-schedule-templates/_store/fee-schedule-templates-redux-slice";
import commentsSlice from "work/proposals/comments/_store/comments-redux-slice";
import commentThreadsSlice from "work/proposals/comments/threads/_store/comment-thread-redux-slice";
import teamTemplatesSlice from "work/team-templates/_store/team-templates-redux-slice";
import workAgreementsSlice from "work/work-agreements/_store/work-agreement-redux-slice";
import vendorTeamsSlice from "work/work-agreements/teams/vendor-team/_store/vendor-teams-redux-slice";
import { marketplaceSlice } from "marketplace/_stores/marketplace-redux-slice";

export const rootReducer = combineReducers({
  [api.reducerPath]: api.reducer,

  connectionHealth: connectionHealthReducer,

  // Documents
  documents: documentsSlice.reducer,

  // Legal Entities
  legalEntityAgreements: entityAgreementsSlice.reducer,
  entityOfficerInvitations: officerInvitationsSlice.reducer,
  entityMembers: entityMembersSlice.reducer,
  openEntityMemberInvitations: openEntityMemberInvitationsSlice.reducer,
  userEntityMemberInvitations: userEntityMemberInvitationsSlice.reducer,

  // Marketplace
  bookmarks: bookmarksSlice.reducer,
  individuals: individualsSlice.reducer,
  companies: companiesSlice.reducer,
  teams: marketplaceTeamsSlice.reducer,
  feeSchedules: feeSchedulesSlice.reducer,

  // Messaging
  forums: forumsSlice.reducer,
  messages: messagesSlice.reducer,
  attachments: attachmentsSlice.reducer,

  // Permissions
  permissions: permissionsSlice.reducer,
  permissionTemplates: permissionTemplatesSlice.reducer,

  // Notifications
  notifications: notificationsSlice.reducer,

  // Work
  proposals: proposalsSlice.reducer,
  workAgreements: workAgreementsSlice.reducer,
  feeScheduleTemplates: feeScheduleTemplatesSlice.reducer,
  teamTemplates: teamTemplatesSlice.reducer,
  vendorTeams: vendorTeamsSlice.reducer,

  commentThreads: commentThreadsSlice.reducer,
  comments: commentsSlice.reducer,

  // Marketplace
  marketplace: marketplaceSlice.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;
